import React from "react";
import styled from "styled-components";
import ShopSearch from "../../components/combinations/ShopSearch";
import Footer from "../../components/combinations/Footer";
import UserHead from "../../config/UserHead";
import NewCafeNotes from "../../components/combinations/NewCafeNotes";
import Notice from "../../components/combinations/Notice";
import Header from "../../components/combinations/Header";
import SearchPrefectureCafe from "../../components/combinations/SearchPrefectureCafe";
import NewShops from "../../components/combinations/NewShops";

const TopStyle = styled.div`
  font-family: "Noto Sana JP", sans-serif;
`;

const Top: React.FC = () => {
  return (
    <TopStyle>
      <UserHead />
      <Header />
      <ShopSearch />
      <NewShops />
      <NewCafeNotes backgroundColor="#f2f0e9" />
      <SearchPrefectureCafe />
      <Notice backgroundColor="#f2f0e9" />
      <Footer />
    </TopStyle>
  );
};
export default Top;
